module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.18759/js/img/ebx633/hero-bg.svg"